import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Acl } from 'modules/common/components/Acl';
import PropTypes from 'prop-types';
import moment from 'moment';
import { getJson } from 'session';
import { ModalContext } from 'App';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as action from '../action';
import * as c from '../constant';
import UpdateViolationTicketModal from '../modals/UpdateViolationTicketModal';
import UpdateViolationModal from '../modals/UpdateViolationModal';

function TransactionContent({
  transactionInfo,
  showTransactionTrafficViolator,
  clearTransaction,
  isLoading,
  match,
  approveViolator,
  traffic_violators,
  isApproving,
  permissions,
  disapproveViolator,
  isDisapproving,
}) {
  const setModal = useContext(ModalContext);
  const selectedTransaction = match.params.id;
  const isApproved = _.get(transactionInfo, 'attributes.is_approved') === 1;

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateViolationTicketModal
          transaction={transactionInfo}
          updateList={data.attributes}
          id={data.id}
        />
      ),
      title: `Update Violator's Information`,
      modalSize: 'modal-xl',
    });
  };

  const handleViolationEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateViolationModal
          violationData={data}
          ovrid={selectedTransaction}
        />
      ),
      title: `Update Violation`,
      modalSize: 'modal-md',
    });
  };

  const updateData = () => {
    showTransactionTrafficViolator(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const getInitials = (cString) => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- .]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val?.slice(0, 2);
      const final = strFirstTwo?.join('');
      return final?.toUpperCase();
    }
    return null;
  };

  const handleApprove = (data) => (e) => {
    e.preventDefault();
    const args = {
      ...data.attributes,
      apprehended_at: _.get(data, 'attributes.apprehended_at') || '',
      driver_license_validity_date_from: _.get(
        data,
        'attributes.driver_license_validity_date_from'
      )
        ? moment(
            _.get(data, 'attributes.driver_license_validity_date_from')
          ).format('MM/DD/YYYY')
        : '',
      driver_license_validity_date_to: _.get(
        data,
        'attributes.driver_license_validity_date_to'
      )
        ? moment(
            _.get(data, 'attributes.driver_license_validity_date_to')
          ).format('MM/DD/YYYY')
        : '',
      birth_date: _.get(data, 'attributes.birth_date')
        ? moment(_.get(data, 'attributes.birth_date')).format('MM/DD/YYYY')
        : '',
      is_approved: 1,
    };

    approveViolator(selectedTransaction, args, () => {
      updateData();
    });
  };

  const handleDisapprove = (data) => (e) => {
    e.preventDefault();
    const args = {
      ...data.attributes,
      apprehended_at: _.get(data, 'attributes.apprehended_at') || '',
      driver_license_validity_date_from:
        moment(
          _.get(data, 'attributes.driver_license_validity_date_from')
        ).format('MM/DD/YYYY') || '',
      driver_license_validity_date_to:
        moment(
          _.get(data, 'attributes.driver_license_validity_date_to')
        ).format('MM/DD/YYYY') || '',
      birth_date:
        moment(_.get(data, 'attributes.birth_date')).format('MM/DD/YYYY') || '',
      is_approved: 1,
    };
    disapproveViolator(selectedTransaction, args, () => {
      updateData();
    });
  };

  const RenderViolations = () => {
    const violations = _.get(traffic_violators, 'violations') || [];
    return violations.map((data) => {
      return (
        <tr key={data.violation_code}>
          <td>{data.violation_code}</td>
          <td>{data.particular}</td>
          <td>{data.reference}</td>
          <td>{data.amount}</td>
          <td className="d-flex">
            <button
              type="button"
              className="btn-blank"
              onClick={handleViolationEdit(data)}
              disabled={isApproved}
            >
              <i className={`far fa-edit ${isApproved ? 'icon-disabled' : 'icon-edit'}`} />
            </button>
          </td>
        </tr>
      );
    });
  };

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        {!_.isEmpty(traffic_violators) ? (
          <div className="right-section-content">
            {/* GRAY HIGHLIGHT */}
            <div className="row highlight d-flex align-items-center mx-1 py-3">
              <div className="col-12 px-0 mt-0 mb-1 ">
                {/* BORDER */}
                <div className="card border-primary">
                  <div className="container-fluid py-1">
                    <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                      <div className="d-flex round-image justify-content-center">
                        <h3 className="d-flex align-items-center initials mb-0">
                          {getInitials(
                            `${_.get(traffic_violators, 'first_name')} ${_.get(
                              traffic_violators,
                              'middle_name'
                            )} ${_.get(traffic_violators, 'last_name')}`
                          )}
                        </h3>
                      </div>
                      <div className="d-flex ml-4 align-items-center">
                        <h1 className="transaction-company m-0">
                          {`${_.get(traffic_violators, 'first_name') || '-'} ${
                            _.get(traffic_violators, 'middle_name') || ''
                          } ${_.get(traffic_violators, 'last_name') || ''} ${
                            _.get(traffic_violators, 'extension_name') || ''
                          }`}
                        </h1>
                      </div>
                      <div className="ovrs-button-container my-2">
                        {_.get(traffic_violators, 'is_valid') &&
                        !_.get(traffic_violators, 'is_approved') &&
                        Acl(permissions, [
                          'VIEW OVRS DISAPPROVE VIOLATION TICKET',
                        ]) ? (
                          <button
                            disabled={isDisapproving}
                            onClick={handleDisapprove(transactionInfo)}
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mx-2"
                            type="button"
                          >
                            Disapprove
                          </button>
                        ) : (
                          ''
                        )}
                        {!_.get(traffic_violators, 'is_valid') &&
                          Acl(permissions, [
                            'VIEW OVRS APPROVE VIOLATION TICKET',
                          ]) && (
                            <button
                              disabled={isApproving}
                              onClick={handleApprove(transactionInfo)}
                              className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mx-2"
                              type="button"
                            >
                              Approve
                            </button>
                          )}
                        {!_.get(traffic_violators, 'is_valid') &&
                          Acl(permissions, [
                            'VIEW OVRS EDIT VIOLATION TICKET',
                          ]) && (
                            <button
                              onClick={handleEdit(transactionInfo)}
                              className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold ml-2"
                              type="button"
                            >
                              Edit
                            </button>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-1 pb-1 px-3">
              <div className="col-12">
                <table className="transaction-table table table-borderless table-sm table-striped table-hover">
                  <tbody>
                    <tr>
                      <td className="text-dark" width="300">
                        OVR Number
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>
                          {(
                            _.get(traffic_violators, 'ovr_number') || '--'
                          ).toUpperCase()}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        OVR Status
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>
                          {_.get(traffic_violators, 'is_valid')
                            ? 'APPROVED'
                            : 'WAITING FOR APPROVAL'}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Application Status
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>{_.get(traffic_violators, 'application_status')}</b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Transmittal Number
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>{_.get(traffic_violators, 'transmittal_no')}</b>
                      </td>
                    </tr>
                    {_.get(traffic_violators, 'is_valid') ? (
                      <>
                        <tr>
                          <td className="text-dark" width="300">
                            Approved By:
                          </td>
                          <td className="text-dark" width="1">
                            :
                          </td>
                          <td>
                            <b>
                              {_.get(traffic_violators, 'approved_by') || ''}
                            </b>
                          </td>
                        </tr>
                        <tr>
                          <td className="text-dark" width="300">
                            Approved At:
                          </td>
                          <td className="text-dark" width="1">
                            :
                          </td>
                          <td>
                            <b>
                              {moment(
                                _.get(traffic_violators, 'approved_at')
                              ).format('MM/DD/YYYY') || '--'}
                            </b>
                          </td>
                        </tr>
                      </>
                    ) : null}
                    <tr>
                      <td className="text-success" colSpan={3}>
                        <b>VIOLATOR&apos;S PERSONAL INFORMATION</b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Last Name
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>
                          {(
                            _.get(traffic_violators, 'last_name') || '--'
                          ).toUpperCase()}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Middle Name
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>
                          {(
                            _.get(traffic_violators, 'middle_name') || '--'
                          ).toUpperCase()}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        First Name
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>
                          {(
                            _.get(traffic_violators, 'first_name') || '--'
                          ).toUpperCase()}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Extension Name
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>
                          {(
                            _.get(traffic_violators, 'extension_name') || '--'
                          ).toUpperCase()}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Date of Birth
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>
                          {_.get(traffic_violators, 'birth_date')
                            ? moment(
                                _.get(traffic_violators, 'birth_date')
                              ).format('MM/DD/YYYY')
                            : '--'}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Mobile Number
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>
                          {_.get(traffic_violators, 'mobile_number') || '--'}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Place of Birth
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>
                          {(
                            _.get(
                              transactionInfo,
                              'included.region.attributes.name'
                            ) || '--'
                          ).toUpperCase()}
                          ,
                          {(
                            _.get(
                              transactionInfo,
                              'included.province.attributes.name'
                            ) || '--'
                          ).toUpperCase()}{' '}
                          {(
                            _.get(
                              transactionInfo,
                              'included.municipality.attributes.name'
                            ) || '--'
                          ).toUpperCase()}{' '}
                          {(
                            _.get(
                              transactionInfo,
                              'included.barangay.attributes.name'
                            ) || '--'
                          ).toUpperCase()}{' '}
                          {(
                            _.get(traffic_violators, 'street') || '--'
                          ).toUpperCase()}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-success" colSpan={3}>
                        <b>VIOLATOR&apos;S DRIVERS LICENSE INFORMATION</b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Driver License Number
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>
                          {(
                            _.get(traffic_violators, 'driver_license_number') ||
                            '--'
                          ).toUpperCase()}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Valid From
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>
                          {(
                            _.get(
                              traffic_violators,
                              'driver_license_validity_date_from'
                            ) || '--'
                          ).toUpperCase()}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Valid To
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>
                          {(
                            _.get(
                              traffic_violators,
                              'driver_license_validity_date_to'
                            ) || '--'
                          ).toUpperCase()}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-success" colSpan={3}>
                        <b>APPREHENSION INFORMATION</b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Date of Apprehension
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>
                          {(
                            _.get(traffic_violators, 'apprehended_at') || '--'
                          ).toUpperCase()}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Vehicle Type
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>
                          {(
                            _.get(traffic_violators, 'vehicle_type') || '--'
                          ).toUpperCase()}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Vehicle Plate Number
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>
                          {(
                            _.get(traffic_violators, 'vehicle_plate_number') ||
                            '--'
                          ).toUpperCase()}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Apprehending Officer
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>
                          {(
                            _.get(
                              transactionInfo,
                              'included.apprehending_officer.attributes.name'
                            ) || '--'
                          ).toUpperCase()}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Place of Apprehension
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>
                          {(
                            _.get(
                              transactionInfo,
                              'included.apprehension_region.attributes.name'
                            ) || '--'
                          ).toUpperCase()}{' '}
                          {(
                            _.get(
                              transactionInfo,
                              'included.apprehension_province.attributes.name'
                            ) || '--'
                          ).toUpperCase()}{' '}
                          {(
                            _.get(
                              transactionInfo,
                              'included.apprehension_municipality.attributes.name'
                            ) || '--'
                          ).toUpperCase()}{' '}
                          {(
                            _.get(
                              transactionInfo,
                              'included.apprehension_barangay.attributes.name'
                            ) || '--'
                          ).toUpperCase()}{' '}
                          {(
                            _.get(traffic_violators, 'apprehension_street') ||
                            '--'
                          ).toUpperCase()}{' '}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Original Total Amount
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>
                          {_.get(traffic_violators, 'original_total_amount') ||
                            '--'}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Discount
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td>
                        <b>{_.get(traffic_violators, 'discount') || '--'}</b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="300">
                        Total Amount
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td style={{ fontSize: '15px' }}>
                        <b>
                          {_.get(traffic_violators, 'total_amount') || '--'}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
                List of Violations
                <div>
                  <div className="violation-container table-responsive">
                    <table className="table table-borderless table-sm table-striped table-hover">
                      <thead>
                        <tr>
                          <th scope="scope">Violation Code</th>
                          <th scope="scope">Particular</th>
                          <th scope="scope">Reference</th>
                          <th scope="scope">Amount</th>
                          <th scope="scope">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <RenderViolations />
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

TransactionContent.propTypes = {
  permissions: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  traffic_violators: PropTypes.instanceOf(Object).isRequired,
  showTransactionTrafficViolator: PropTypes.instanceOf(Function).isRequired,
  approveViolator: PropTypes.instanceOf(Function).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  disapproveViolator: PropTypes.instanceOf(Function).isRequired,
  isDisapproving: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isApproving: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  transactionInfo: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
  traffic_violators:
    {
      ...(_.get(api, `${c.SHOW_TRANSACTION}.item.attributes`) || {}),
    } || {},
  isLoading: api.loading.indexOf(c.SHOW_TRANSACTION) > -1,
  isApproving: api.loading.indexOf(c.APPROVE_VIOLATOR) > -1,
  isDisapproving: api.loading.indexOf(c.DISAPPROVE_VIOLATOR) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(TransactionContent);
